import {
  setMergedColRowSpanKey,
  transformMergeCellsToRowColSpanResult,
  calculateEqualMergeCells
} from '../config/merge-cell'
import { getValue } from '../../utils/tools'

export default {
  data() {
    return {
      states: {
        mergeRowspanMaps: {
          // '0, 1, 2': {
          //   mergeIndex: [0, 1, 2],
          //   mergeSum: 3
          // },
          // '3, 4, 5': {
          //   mergeIndex: [3, 4, 5],
          //   mergeSum: 3
          // },
        },
        mergedColRowSpanResult: {
          // rowIndex - columnIndex: {}
        },
        mergeColspanMaps: {},
        // lastIndexMergeMaps: {},
        equalCellsMap: {}
      }
    }
  },
  methods: {
    setMergedColRowSpanKey,
    // 获取合并行列的key值。
    getColRowSpanResult(rowIndex, columnIndex) {
      const key = setMergedColRowSpanKey(rowIndex, columnIndex)
      return this.states.mergedColRowSpanResult[key]
    },
    // 存储合并行列的结果集。以 rowIndex、columnIndex为维度
    setMergedColRowSpanResult({ rowIndex, columnIndex, colRowSpan }) {
      const key = setMergedColRowSpanKey(rowIndex, columnIndex)
      this.states.mergedColRowSpanResult[key] = colRowSpan
    },
    /**
     *
     * @description 把单元格的值，按列或者行以数组的方式记录下来对应的位置信息
     * @param {*} cellValue
     * @param {*} { key, column, rowIndex, columnIndex }
     * @description 实际结构如下 以row行来存储时，则key为每一行的索引值rowIndex，value则为列的索引值columnIndex
     *      下面表示在表格中 以行（row）来看，第一行的第一列，第二行的第一列，第三行的3、4、5列的单元格值为 ‘cs’
     *      以列（col）来看，第一列的1、2行，第3列的第二行，第4列的第二行，第5列的第二行的单元格的值为‘cs’
     *      {
     *        'cs': {
     *                  row: {0: [0], 1: [0], 2: [2,3,4]},
     *                  col: {0: [0, 1], 2: [2], 3: [2], 4: [2]},
     *                  key: 'xxx',
     *                  column
     *              }
     *      }
     */
    setEqualCellsMap(cellValue, { key, column, rowIndex, columnIndex }) {
      if (!this.states.equalCellsMap[cellValue]) {
        this.states.equalCellsMap[cellValue] = {
          row: {},
          col: {},
          key,
          column
        }
      }
      const iter = (direction, isRow) => {
        const index = isRow ? rowIndex : columnIndex
        const value = isRow ? columnIndex : rowIndex
        if (!this.states.equalCellsMap[cellValue][direction][index]) {
          this.states.equalCellsMap[cellValue][direction][index] = []
        }
        this.states.equalCellsMap[cellValue][direction][index].push(value)
      }
      // 行记录列
      iter('row', true)
      // 列记录行
      iter('col', false)
    },
    // 执行props的 spanMethods 回调(在数据变更时执行)。存储回调结果。
    calculateSpanMethods(rowData, rowIndex, tableData) {
      if (!this.table.$props.spanMethod) {
        return
      }
      const columns = this.states.mainColumns.filter(i => !(i.children && i.children.length))
      if (columns) {
        for (let i = 0; i < columns.length; i++) {
          const column = columns[i]
          // 使用原始的索引值去做合并列的计算。否则导致位置偏移
          const columnIndex = column.originIndex
          const result = this.table.$props.spanMethod({
            rowData,
            column,
            rowIndex,
            columnIndex,
            tableData
          })
          const colRowSpan = {
            rowspan: 1,
            colspan: 1
          }
          if (Array.isArray(result)) {
            colRowSpan.rowspan = result[0]
            colRowSpan.colspan = result[1]
          } else if (typeof result === 'object') {
            colRowSpan.rowspan = result.rowspan
            colRowSpan.colspan = result.colspan
          }
          this.setMergedColRowSpanResult({
            rowIndex,
            columnIndex,
            colRowSpan
          })
          this.saveMergeCellConfig({
            colRowSpan,
            rowData,
            column,
            rowIndex,
            columnIndex
          })
        }
      }
    },
    clearEqualCellsMap() {
      this.states.equalCellsMap = {}
    },
    /**
     *
     * @description 收集相同的单元格值的单元格信息，此时仅收集。
     * @param {*} rowData
     * @param {*} rowIndex
     * @param {*} tableData
     */
    getEqualCellsMap(rowData, rowIndex, tableData) {
      const mergeEqualCellsOption = this.table.$props.mergeEqualCellsOption
      if (!mergeEqualCellsOption) {
        return
      }
      const { beforeMergeValue, beforeMergeKey = [] } = mergeEqualCellsOption
      const columns = this.states.mainColumns.filter(i => !(i.children && i.children.length))
      if (columns) {
        for (let i = 0; i < columns.length; i++) {
          const column = columns[i]
          const { key, originIndex: columnIndex } = column
          // 使用原始的索引值去做合并列的计算。否则导致位置偏移
          if (['_index'].includes(key)) {
            continue
          }
          let mergeKey =
            typeof beforeMergeKey === 'function' &&
            beforeMergeKey({ column, rowData, columnIndex, rowIndex, tableData })
          let cellValue = getValue(mergeKey || key, rowData)
          if (beforeMergeValue && typeof beforeMergeValue === 'function') {
            cellValue = beforeMergeValue({ column, rowData, value: cellValue, rowIndex, columnIndex, tableData })
          }
          // undefined null NaN不做处理
          if (cellValue === undefined || cellValue === null) {
            continue
          }
          // 为什么要加 key。为了防止。多个key下相同的数据，导致key不同而产生合并的问题出现
          cellValue = key + '_' + cellValue
          if (!this.states.equalCellsMap[cellValue]) {
            this.states.equalCellsMap[cellValue] = {
              row: {},
              col: {},
              key,
              column,
              tableData
            }
          }
          if (!this.states.equalCellsMap[cellValue]['row'][rowIndex]) {
            this.states.equalCellsMap[cellValue]['row'][rowIndex] = []
          }
          if (!this.states.equalCellsMap[cellValue]['col'][columnIndex]) {
            this.states.equalCellsMap[cellValue]['col'][columnIndex] = []
          }
          // 行记录列
          this.states.equalCellsMap[cellValue]['row'][rowIndex].push(columnIndex)
          // 列记录行
          this.states.equalCellsMap[cellValue]['col'][columnIndex].push(rowIndex)
        }
      }
    },
    transformMergeCellsToRowColSpanResult(mergeCells) {
      const obj = transformMergeCellsToRowColSpanResult(mergeCells)
      if (!obj) {
        return
      }
      const { mergeColspanMaps = {}, mergeRowspanMaps = {}, mergedColRowSpanResult = {} } = obj
      this.states.mergeColspanMaps = mergeColspanMaps
      this.states.mergeRowspanMaps = mergeRowspanMaps
      this.states.mergedColRowSpanResult = mergedColRowSpanResult
    },
    /**
     * @description 计算相同单元格合并行列的数据
     *
     */
    calculateEqualMergeCells() {
      const equalCellsMap = this.states.equalCellsMap
      const mergeEqualCellsOption = this.table.$props.mergeEqualCellsOption
      const mergeCells = this.table.$props.mergeCells
      // 如果是用户自己设置好的，则直接转换为对应的rowspan\colspan
      if (mergeCells) {
        this.transformMergeCellsToRowColSpanResult(mergeCells)
      } else {
        // 反之使用
        if (Object.keys(equalCellsMap).length) {
          const mergeCells = calculateEqualMergeCells(equalCellsMap, mergeEqualCellsOption)
          this.transformMergeCellsToRowColSpanResult(mergeCells)
        }
      }
    },
    // 清除合并列与合并行
    clearMergeRowColspanMap() {
      this.states.mergeRowspanMaps = {}
      this.states.mergeColspanMaps = {}
      this.states.mergedColRowSpanResult = {}
    },
    // 设置合并列与合并行
    saveMergeCellConfig(data) {
      const { colRowSpan = {}, rowIndex, columnIndex } = data || {}
      const { rowspan, colspan } = colRowSpan
      if (rowspan > 1) {
        const mergeIndex = Array.from({ length: rowspan }, (_, index) => index + rowIndex)
        const mergeCellKey = mergeIndex.join(',')
        this.states.mergeRowspanMaps[mergeCellKey] = {
          mergeSum: rowspan,
          mergeIndex,
          mergeStartIndex: mergeIndex[0],
          mergeEndIndex: mergeIndex[mergeIndex.length - 1]
        }
      }
      if (colspan > 1) {
        const mergeIndex = Array.from({ length: colspan }, (_, index) => index + columnIndex)
        const mergeCellKey = mergeIndex.join(',')
        this.states.mergeColspanMaps[mergeCellKey] = {
          mergeSum: colspan,
          mergeIndex,
          mergeStartIndex: mergeIndex[0],
          mergeEndIndex: mergeIndex[mergeIndex.length - 1]
        }
      }
    },
    // 计算索引值 是否在 cellMap的合并集合内。存在则返回对应 合并起始值与区间集合
    computedMergeCell(index, cellMap = {}) {
      const mergeCellKeys = Object.keys(cellMap)
      const mergeCellKey = mergeCellKeys.findIndex(
        ids => ids.split(',').length && ids.split(',').some(id => +id === index)
      )
      if (!mergeCellKeys.length || mergeCellKey === -1) return false
      const mergeKey = mergeCellKeys[mergeCellKey]
      const mergeItem = cellMap[mergeKey]
      return {
        mergeCellStart: mergeItem.mergeIndex[0], // 保证每一组都能被正常渲染出来
        mergeIndex: mergeItem.mergeIndex
      }
    },
    // 计算纵向结束区间值是否为合并列中的一员，是否返回当前位置后面剩下的长度个数，补齐未渲染的个数。
    computedRangeEndInMergedCell(end, cellMap = {}) {
      // 如果虚拟列表区间的结束值，包含在合并的列中，且不是最后一项，则需要计算其他的子项。因为合并需要展示完全
      const mergeCellKeys = Object.keys(cellMap)
      const mergeCellKey = mergeCellKeys.findIndex(ids => {
        const idsArray = ids.split(',')
        return idsArray.length && idsArray.some(id => +id === end)
      })
      if (!mergeCellKeys.length || mergeCellKey === -1) return 0
      const mergeKey = mergeCellKeys[mergeCellKey]
      const mergeItem = cellMap[mergeKey]
      const length = mergeItem.mergeIndex.length - (mergeItem.mergeIndex.findIndex(i => i === end) + 1)
      return length
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/merge-cell.js